import { Dialog, DialogContent } from '@mui/material'
import React from 'react'
import CreatEdit from './CreateEdit'
import  './assetTypeModal.css';

function AssetTypeCreateModal({handleClose,productId,setNewValue}) {
  return (
    <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={true}
        onClose={handleClose}
      >
       
        <DialogContent className="modalContainer">
          <CreatEdit  setNewValue={setNewValue} closeCreateEditForm={handleClose} assetTypeEditDatas={null} editStatus={false} productId={productId}/>
        </DialogContent>
       
      </Dialog>
  )
}

export default AssetTypeCreateModal